import moment from 'moment'

export const dateKeys = [
  'createdAt',
  'updatedAt',
  'projectStartDate',
  'projectEndDate',
  'offerSubmissionDate',
  'quotationSubmittedDate',
  'quotationCompletedDate',
  'bookingCompletedDate',
  'legalProjectCompletionDate',
  'bookingCreateDate',
  'bookingStartDate',
  'bookingEndDate',
  'bookingSubmittedDate',
  'bookingCustomerPODate',
  'damexCreateDate',
  'damexConfirmDate',
  'sourcingDueDate',
  'costBudgetRfqValidDate',
  'costBudgetRfqSubmitDate',
]

const amountKeys = ['costBudgetQuoteAmount', 'costBudgetRfqQuotationAmount']

const selectionKeys = [
  'costBudgetPM040SourcingSelection',
  'costBudgetPM040TechnicalSelection',
  'costBudgetPM100TechnicalSelection',
]

export const buildDownloadRow = (data, headerKeys) => {
  const row = []

  headerKeys.forEach((key) => {
    const value = data[key]

    if (dateKeys.includes(key)) {
      const date = value === undefined || value === null ? null : moment(value)
      row.push(date && date.isValid() ? date.format('DD-MMM-YYYY') : '(-)')
      return
    }

    if (amountKeys.includes(key)) {
      row.push(Number(value) || 0)
      return
    }

    if (key === 'costBudgetRfqSelection') {
      row.push(Array.isArray(value) && value.length > 0 ? value.join(', ') : '(-)')
      return
    }

    if (selectionKeys.includes(key)) {
      const vendorName = value ? value.replace(/^(selected|reference)-/, '') : value
      row.push(!vendorName || vendorName === '(-)' ? '' : vendorName)
      return
    }

    if (key.includes('Percentage')) {
      row.push(value === undefined || value === null ? '(-)' : Number(value) / 100)
      return
    }

    row.push(value === undefined || value === null || value === '' ? '(-)' : value)
  })

  return row
}
